import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import toast from "react-hot-toast";
import Gallery from "../../components/Gallery";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import { triggerChooseimg } from "../../components/ChooseImg";
import axiosInstance from "../../../axiosInstance";

const PINCODE_REGEX = /^\d{6}$/;

const EditZones = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(true);
  const [editorValue, setEditorValue] = useState("");

  // NEW: inputs for pincode/area management
  const [pincodeInput, setPincodeInput] = useState("");
  const [areaInputs, setAreaInputs] = useState({}); // { "122001": "Sector 14" }
  const [expanded, setExpanded] = useState({}); // accordion open/close per pincode

  const { slug } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    primary: false,   // make these booleans (React-friendly)
    status: true,
    pincodes: {},       // { "122001": ["Area A", "Area B"] }
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : (name === "status" ? value === "true" : value),
    }));
  };

  const fetchData = async () => {
    try {
      const { data } = await axiosInstance.get(`/admin/get-zones/${slug}`);
      setData(data.Zones);
      setLoading(false);

      const pincodeObj = {};
(data.Zones?.pincodes || []).forEach((item) => {
  if (item.code) pincodeObj[item.code] = item.areas || [];
});

      setFormData((prev) => ({
        ...prev,
        name: data.Zones?.name ?? "",
        // Your API returns "true"/"false" sometimes; coerce to boolean safely
        status: typeof data.Zones?.status === "boolean"
          ? data.Zones.status
          : (String(data.Zones?.status).toLowerCase() === "true"),
        primary: typeof data.Zones?.primary === "boolean"
          ? data.Zones.primary
          : (String(data.Zones?.primary).toLowerCase() === "true"),
        // Use pincodes if present; if backend later moves to 'pincodes', adapt here:
        pincodes: pincodeObj,

      }));
    } catch (error) {
      console.log(error);
      toast.error("Error fetching zone!");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ---------- PINCODE + AREAS LOGIC ----------
  const addPincode = () => {
    const code = (pincodeInput || "").trim();
    if (!PINCODE_REGEX.test(code)) {
      toast.error("Enter a valid 6-digit pincode.");
      return;
    }
    if (formData.pincodes[code]) {
      toast("Pincode already exists.", { icon: "ℹ️" });
      return;
    }
    setFormData((prev) => ({
      ...prev,
      pincodes: { ...prev.pincodes, [code]: [] },
    }));
    setPincodeInput("");
    setExpanded((prev) => ({ ...prev, [code]: true }));
    toast.success("Pincode added.");
  };

  const removePincode = (code) => {
    const next = { ...formData.pincodes };
    delete next[code];
    setFormData((prev) => ({ ...prev, pincodes: next }));
    const nextAreas = { ...areaInputs };
    delete nextAreas[code];
    setAreaInputs(nextAreas);
    const nextExp = { ...expanded };
    delete nextExp[code];
    setExpanded(nextExp);
    toast.success("Pincode removed.");
  };

  const addArea = (code) => {
    const area = (areaInputs[code] || "").trim();
    if (!area) {
      toast.error("Area name cannot be empty.");
      return;
    }
    const current = formData.pincodes[code] || [];
    if (current.map((a) => a.toLowerCase()).includes(area.toLowerCase())) {
      toast("Area already exists for this pincode.", { icon: "ℹ️" });
      return;
    }
    const updated = [...current, area];
    setFormData((prev) => ({
      ...prev,
      pincodes: { ...prev.pincodes, [code]: updated },
    }));
    setAreaInputs((prev) => ({ ...prev, [code]: "" }));
    toast.success("Area added.");
  };

  const removeArea = (code, area) => {
    const updated = (formData.pincodes[code] || []).filter((a) => a !== area);
    setFormData((prev) => ({
      ...prev,
      pincodes: { ...prev.pincodes, [code]: updated },
    }));
    toast.success("Area removed.");
  };

    const pincodeList = Object.keys(formData.pincodes || {}).sort();


  const submitData = async () => {
    setSubmitLoading(false);
 const updatedata = {
  ...formData,
  pincodes: Object.fromEntries(
    Object.entries(formData.pincodes || {}).sort(([a], [b]) => a.localeCompare(b))
  ),
};

console.log('updatedata',updatedata)
    try {
      // send as-is; your backend can store pincodes mapping
      await axiosInstance.put(`/admin/update-zones/${slug}`, updatedata);
      toast.success("Zones updated successfully!");
      navigate("/all-zones");
    } catch (error) {
      console.error("Error On zones:", error);
      toast.error(error?.response?.data?.message || "Update failed");
    } finally {
      setSubmitLoading(true);
    }
  };


  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />

        <div className="py-4">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit Zones
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">Edit Zones</h1>
            </div>
            <div>
              <Link
                to="/all-zones"
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
                onClick={() => navigate("/admin/all-company")}
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>
          </div>
        </div>

        <div id="add-blog-form">
          <div className="row">
            {/* LEFT */}
            <div className="col-md-8 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">
                  {loading ? (
                    <>
                      {/* Skeletons (unchanged) */}
                      <div className="row mb-4">
                        <div className="col-lg-12 col-sm-12">
                          <div className="row">
                            <br />
                            <div className="col-md-12">
                              <div className="mb-4">
                                <p
                                  className="skeleton"
                                  style={{
                                    width: "100%",
                                    borderRadius: 5,
                                    margin: "0px auto 10px",
                                    height: 70,
                                  }}
                                ></p>
                              </div>
                            </div>
                            {[...Array(6)].map((_, i) => (
                              <div className="col-md-6" key={i}>
                                <div className="mb-4">
                                  <p
                                    className="skeleton"
                                    style={{
                                      width: "100%",
                                      borderRadius: 5,
                                      margin: "0px auto 10px",
                                      height: 70,
                                    }}
                                  ></p>
                                </div>
                              </div>
                            ))}
                            <div className="col-md-12">
                              <div className="mb-4">
                                <p
                                  className="skeleton"
                                  style={{
                                    width: "100%",
                                    borderRadius: 5,
                                    margin: "0px auto 10px",
                                    height: 135,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* BASIC FIELDS */}
                      <div className="row mb-4">
                        <div className="col-lg-12 col-sm-12">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-4">
                                <label htmlFor="name">Name</label>
                                <input
                                  type="text"
                                  value={formData.name}
                                  className="form-control"
                                  id="name"
                                  name="name"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>

                            <div className="col-6 row">
                              <div className="col-4">
                                <div className="mb-4">
                                  <label className="my-1 me-2" htmlFor="primary">
                                    Set Primary
                                  </label>
                                </div>
                              </div>
                              <div className="col-8">
                                <div className="mb-4">
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="primary"
                                      id="primary"
                                      checked={!!formData.primary}
                                      onChange={handleChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* ---- NEW: PINCODE & AREAS MANAGER ---- */}
                          <hr />
                          <div className="mb-2 d-flex align-items-end gap-2">
                            <div className="flex-grow-1 m-0">
                              <label htmlFor="pincode">Add Pincode</label>
                              <input
                                id="pincode"
                                type="text"
                                className="form-control"
                                placeholder="6-digit pincode e.g. 122018"
                                value={pincodeInput}
                                maxLength={6}
                                onChange={(e) => setPincodeInput(e.target.value.replace(/\D/g, ""))}
                              />
                             </div>
                            <button
                              type="button"
                              className="btn btn-primary mb-0"
                              onClick={addPincode}
                           
                            >
                              Add
                            </button>
                          </div>

                          {pincodeList.length === 0 ? (
                            <p className="text-muted mt-2">No pincodes added yet.</p>
                          ) : (
                            <div className="accordion mt-3" id="pincodeAccordion">
                              {pincodeList.map((code) => {
                                const isOpen = !!expanded[code];
                                const areas = formData.pincodes[code] || [];
                                return (
                                  <div className="card mb-2" key={code}>
                                    <div
                                      className="card-header d-flex justify-content-between align-items-center py-2"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        setExpanded((prev) => ({ ...prev, [code]: !prev[code] }))
                                      }
                                    >
                                      <div>
                                        <strong>{code}</strong>{" "}
                                        <span className="badge bg-light text-dark">
                                          {areas.length} area{areas.length !== 1 ? "s" : ""}
                                        </span>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger btn-sm"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removePincode(code);
                                          }}
                                        >
                                          Remove
                                        </button>
                                        <span
                                          className={`ms-2 ${
                                            isOpen ? "rotate-180" : ""
                                          }`}
                                          style={{ transition: "transform .2s" }}
                                        >
                                   ⬇️ 
                                        </span>
                                      </div>
                                    </div>

                                    {isOpen && (
                                      <div className="card-body">
                                        {/* Areas chips */}
                                        {areas.length ? (
                                          <div className="mb-3">
                                            {areas.map((area) => (
                                              <span
                                                key={area}
                                                className="badge bg-secondary me-2 mb-2"
                                              >
                                                {area}{" "}
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-link text-white ms-1 p-0"
                                                  onClick={() => removeArea(code, area)}
                                                  title="Remove"
                                                >
                                                  ×
                                                </button>
                                              </span>
                                            ))}
                                          </div>
                                        ) : (
                                          <p className="text-muted mb-3">No areas yet.</p>
                                        )}

                                        {/* Add area input */}
                                        <div className="d-flex align-items-end gap-2">
                                          <div className="flex-grow-1">
                                            <label htmlFor={`area-${code}`}>Add Area</label>
                                            <input
                                              id={`area-${code}`}
                                              type="text"
                                              className="form-control"
                                              placeholder="e.g. Sector 47"
                                              value={areaInputs[code] || ""}
                                              onChange={(e) =>
                                                setAreaInputs((prev) => ({
                                                  ...prev,
                                                  [code]: e.target.value,
                                                }))
                                              }
                                            />
                                          </div>
                                          <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            onClick={() => addArea(code)}
                                            style={{ height: 38 }}
                                          >
                                            Add
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                          {/* ---- /NEW ---- */}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-md-4 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">
                  {loading ? (
                    <>
                      {/* Skeletons (unchanged) */}
                      <div className="row">
                        <h5
                          className="skeleton"
                          style={{
                            width: "100%",
                            borderRadius: 5,
                            margin: "0px auto 10px",
                            height: 50,
                          }}
                        ></h5>

                        <hr />

                        <p
                          className="skeleton mb-3"
                          style={{
                            width: "100%",
                            borderRadius: 5,
                            margin: "0px auto 10px",
                            height: 250,
                          }}
                        ></p>

                        <div className="col-6 ">
                          <p
                            className="skeleton mb-3"
                            style={{
                              width: "100%",
                              borderRadius: 5,
                              margin: "0px auto 10px",
                              height: 40,
                            }}
                          ></p>
                        </div>
                      </div>
                      <div className="col-6">
                        <p
                          className="skeleton mb-3"
                          style={{
                            width: "100%",
                            borderRadius: 5,
                            margin: "0px auto 10px",
                            height: 40,
                          }}
                        ></p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-4 ">
                          <div className="mb-4">
                            <label className="my-1 me-2" htmlFor="status">
                              Status
                            </label>
                          </div>
                        </div>

                        <div className="col-8 ">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="status"
                              id="status-true"
                              value="true"
                              onChange={handleChange}
                              checked={formData.status === true}
                            />
                            <label className="form-check-label text-success" htmlFor="status-true">
                              Active
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input text-danger"
                              type="radio"
                              name="status"
                              id="status-false"
                              value="false"
                              onChange={handleChange}
                              checked={formData.status === false}
                            />
                            <label className="form-check-label text-danger" htmlFor="status-false">
                              Inactive
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <Gallery />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-12">
                    {SubmitLoading ? (
                      <button className="btn btn-secondary" type="button" onClick={submitData}>
                        Update Zones
                      </button>
                    ) : (
                      <button className="btn btn-secondary btn-sm" type="button" disabled>
                        <span className="ms-1">Loading...</span>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* /RIGHT */}
          </div>
        </div>
      </main>
    </>
  );
};

export default EditZones;
